// extracted by mini-css-extract-plugin
export default {"check_boxes":"check_check_boxes__sbREN"};